import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext.jsx';

export default function useUserDraft(name, initial) {
  const { user } = useAuth();
  const key = `alphaqap:draft:v2:${user?.uid || 'anonymous'}:${name}`;
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key)) ?? initial; } catch { return initial; }
  };
  const [state, setState] = useState(() => ({ key, value: read() }));
  const value = state.key === key ? state.value : read();
  useEffect(() => {
    if (state.key !== key) setState({ key, value: read() });
    else { try { localStorage.setItem(key, JSON.stringify(state.value)); } catch { /* storage may be disabled */ } }
  }, [key, state]);
  return [value, (next) => setState({ key, value: typeof next === 'function' ? next(value) : next })];
}
